




























































import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { CashFlowColumnResult } from "@/models/interface/cash-flow-report/CashFlowReport.interface";
import { currencyFormat } from "@/validator/globalvalidator";
import moment from "moment";
import { Component, Prop, Vue } from "vue-property-decorator";

interface TableRow {
  key: string;
  categoryName: string;
  [key: string]: string | number | undefined;
}

@Component
export default class CashFlowReportTable extends Vue {
  defaultDateFormat = DEFAULT_DATE_FORMAT;
  currencyFormat = currencyFormat;
  moment = moment;

  @Prop({ type: Array, default: () => [] })
  dataSource!: CashFlowColumnResult[];

  @Prop({ type: Boolean, default: false })
  loading!: boolean;

  get tableRows(): TableRow[] {
    if (!this.dataSource.length) return [];

    const rows: TableRow[] = [];
    return rows;
  }
}
